import { render } from "./ClearableSingleSelect.vue?vue&type=template&id=32308872"
import script from "./ClearableSingleSelect.vue?vue&type=script&lang=js"
export * from "./ClearableSingleSelect.vue?vue&type=script&lang=js"
script.render = render

export default script